// AUTO-GENERATED by tools/generate-parallel.mjs --world 9. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 9
// W9 (Quartz) — fifth paid-tier world. 6-color dominant, d=8-9 progression.
import type { LevelDef } from '@tessera/engine';

export const WORLD_9_GENERATED: LevelDef[] = [
  // d*=8  branching=17.18  D=0.032  tiles=13
  {
    id: 'w9-l01',
    world: 9,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3 },
    ],
  },
  // d*=8  branching=14.70  D=0.075  tiles=14
  {
    id: 'w9-l02',
    world: 9,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 3 },
    { coord: { q: -3, r: 0 }, color: 3 },
    ],
  },
  // d*=8  branching=22.29  D=0.101  tiles=13
  {
    id: 'w9-l03',
    world: 9,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: -1, r: 3 }, color: 3 },
    ],
  },
  // d*=8  branching=27.02  D=0.118  tiles=15
  {
    id: 'w9-l04',
    world: 9,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -1 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 3 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: 3, r: 0 }, color: 4 },
    { coord: { q: 2, r: 1 }, color: 4 },
    ],
  },
  // d*=8  branching=19.77  D=0.118  tiles=13
  {
    id: 'w9-l05',
    world: 9,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 3 },
    { coord: { q: 0, r: -3 }, color: 3 },
    ],
  },
  // d*=9  branching=23.40  D=0.403  tiles=15
  {
    id: 'w9-l06',
    world: 9,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 4 },
    { coord: { q: -2, r: 1 }, color: 4 },
    ],
  },
  // d*=9  branching=20.15  D=0.415  tiles=15
  {
    id: 'w9-l07',
    world: 9,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: -3, r: 0 }, color: 3 },
    { coord: { q: -2, r: 3 }, color: 4 },
    { coord: { q: -1, r: 3 }, color: 4 },
    ],
  },
  // d*=9  branching=21.63  D=0.420  tiles=15
  {
    id: 'w9-l08',
    world: 9,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 3 },
    { coord: { q: 3, r: 0 }, color: 4 },
    { coord: { q: -3, r: 1 }, color: 4 },
    ],
  },
  // d*=9  branching=19.19  D=0.435  tiles=15
  {
    id: 'w9-l09',
    world: 9,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 3 },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: -3, r: 0 }, color: 4 },
    { coord: { q: 1, r: -3 }, color: 4 },
    ],
  },
  // d*=9  branching=24.36  D=0.453  tiles=15
  {
    id: 'w9-l10',
    world: 9,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 3 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: -2, r: 3 }, color: 4 },
    { coord: { q: 2, r: 1 }, color: 4 },
    ],
  },
];
